<template>
    <transition name="fade">
        <div id="drink" v-if="show">
            <header class="main fixed">
                <h1><img class="button" src="img/close.svg" width="18" alt="" @click="close" />Pij wodę</h1>
            </header>

            <div class="content v-center">
                <div class="scroll with-padding">
                    <img src="/img/water.svg" width="27" alt="" />
                    <h2>Wypij kilka łyków wody. Dobra kondycja Twojego głosu zależy od nawodnienia organizmu.</h2>
                    <div class="circle-btn">
                        <span @click="close"><img src="img/check.svg" width="27" alt="" /></span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import resize from '../mixins/resize'

    export default {
        name: 'Drink',
        mixins: [resize],
        data() {
            return {
                show: true
            }
        },
        methods: {
            close() {
                this.show = false;
            }
        }
    }
</script>

<style lang="scss">
    @import '../scss/base/transitions';
</style>
